<template>
  <div class="TheMenu">
    <aside class="menu">
      <p class="menu-label">
        Administratif
      </p>
      <ul class="menu-list">
        <li><router-link :to="'/users'">Utilisateurs</router-link></li>
      </ul>
      <p class="menu-label">
        Contenus
      </p>
      <ul class="menu-list">
        <li><router-link :to="'/projects'">Oeuvres</router-link></li>
        <li><router-link :to="'/ateliers'">Ateliers</router-link></li>
        <li><router-link :to="'/actualites'">Actualités</router-link></li>
        <li><router-link :to="'/members'">Membres</router-link></li>
        <li><router-link :to="'/translations'">Traductions</router-link></li>
        <li><router-link :to="'/quotes'">Citations</router-link></li>
        <li><router-link :to="'/pages'">Pages Info</router-link></li>
      </ul>
      <p class="menu-label">
        Taxonomies
      </p>
      <ul class="menu-list">
        <li><router-link :to="'/actutypes'">Types d'actualités</router-link></li>
        <li><router-link :to="'/ateliertypes'">Types d'ateliers</router-link></li>
        <li><router-link :to="'/projecttypes'">Types d'oeuvres</router-link></li>
      </ul>
      <p class="menu-label">
        Métadonnées
      </p>
      <ul class="menu-list">
        <li><router-link :to="'/footer'">Pied de page</router-link></li>
        <li><router-link :to="'/diapo'">Diaporama d'entrée</router-link></li>
        <li><router-link :to="'/langs'">Langues</router-link></li>
        <li><router-link :to="'/destinations'">Destinations</router-link></li>
        <li><router-link :to="'/options'">Options</router-link></li>
        <li><router-link :to="'/redirects'">Redirections</router-link></li>
      </ul>
      <p class="menu-label">Temporaire</p>
      <ul class="menu-list">
        <li>
          <router-link :to="'/newsletter'">Newsletter</router-link>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'TheMenu',
};
</script>

<style lang="scss">
  .TheMenu {
    position: relative;
  }
</style>
